document.addEventListener(
    "DOMContentLoaded", () => {
        // Contents from DOM
        let close = document.querySelector("#mmenuContents .close").textContent;
        let languagenav = document.querySelector("#header .quickAccess__languageSwitcher");

        new Mmenu( "#mainNavigation", {
            "navbars": [
                {
                    "position": "top",
                    "content": [
                        '<div class="closeButton"><a href="#mm-0">' +
                        '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" xml:space="preserve"> <path class="st0" d="M28.9,31.8L0.6,60.1c-0.8,0.8-0.8,2.1,0,2.8C1,63.4,1.5,63.6,2,63.6c0.5,0,1-0.2,1.4-0.6L32,34.4L60.5,63 c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6c0.8-0.8,0.8-2.1,0-2.8L35.1,31.8L63.4,3.4c0.8-0.8,0.8-2.1,0-2.8c-0.8-0.8-2.1-0.8-2.8,0 L32,29.1L3.4,0.6c-0.8-0.8-2.1-0.8-2.8,0c-0.8,0.8-0.8,2.1,0,2.8L28.9,31.8z"/></svg>' +
                        '<span>'+close+'</span>' +
                        '</a></div>',
                        "prev",
                    ]
                },
                {
                    "position": "bottom",
                    "content": [
                        (languagenav) ? `<nav class="mmenu-languageSwitcher d-block d-md-none">${languagenav.innerHTML}</nav>` : ""
                    ]
                }
            ]
        });
    }
);